import { render, staticRenderFns } from "./DividerSeparator.vue?vue&type=template&id=946383f4&scoped=true&"
import script from "./DividerSeparator.vue?vue&type=script&lang=js&"
export * from "./DividerSeparator.vue?vue&type=script&lang=js&"
import style0 from "./DividerSeparator.vue?vue&type=style&index=0&id=946383f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946383f4",
  null
  
)

export default component.exports